import { useTheme } from './useTheme'

/**
 * Legacy composable - redirects to useTheme
 * Kept for backward compatibility
 */
export function useDarkMode() {
  const { isDark, toggleDark: toggleDarkMode, setDark: setDarkMode, initTheme } = useTheme()

  return {
    isDark,
    toggleDarkMode,
    setDarkMode,
    initTheme
  }
}
